import { axiosChartInstance } from "config";
import { useAxiosQuery } from "hooks";

export interface SummaryProgress {
  status: string;
  percentage: number;
  currentStep: string;
  timestamp: string;
  errorMessage?: string;
  isCompleted: boolean;
  hasError: boolean;
}

function useSummaryProgress(encounterId: string, enabled = false) {
  return useAxiosQuery(
    ["summaryProgress", { encounterId }],
    () =>
      axiosChartInstance.get<SummaryProgress>(
        `v1/summary/${encounterId}/progress`
      ),
    {
      enabled,
      refetchInterval: enabled ? 1000 : false,
      refetchIntervalInBackground: false,
      staleTime: 0,
    }
  );
}

export { useSummaryProgress };
